/*=========================================================================================
  File Name: moduleAnalyticsGetters.js
  Description: Analytics Module Getters
==========================================================================================*/

export default {
};
  